<template>
  <span
    role="checkbox"
    tabindex="0"
    aria-checked="false"
    @click="$emit('toggle')"
    class="group relative inline-flex items-center justify-center flex-shrink-0 h-5 w-10 cursor-pointer focus:outline-none"
  >
    <!-- On: "translate-x-5", Off: "translate-x-0" -->

    <!-- On: "bg-blue-600", Off: "bg-gray-200" -->
    <span
      aria-hidden="true"
      class="bg-gray-200 absolute h-3 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200"
      :class="[toggleSwitch?'bg-blue-700':'bg-gray-400']"
    ></span>
    <span
      aria-hidden="true"
      :class="[toggleSwitch?'translate-x-5':'translate-x-0']"
      class="translate-x-0 absolute left-0 inline-block h-5 w-5 border rounded-full bg-white shadow transform group-focus:shadow-outline group-focus:border-blue-400 transition-transform ease-in-out duration-200"
    ></span>
  </span>
</template>

<script>
export default {
  props: {
    toggleSwitch: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
</style>